import {ApiPermissionsModalForm} from './ApiPermissionsModalForm'

const ApiPermissionsModalFormWrapper = ({setOpenAPIpermissionsModal, getUser, user, partnerId}) => {
    return <ApiPermissionsModalForm
        setOpenAPIpermissionsModal={setOpenAPIpermissionsModal}
        getUser={getUser}
        user={user}
        partnerId={partnerId}
    />
}

export {ApiPermissionsModalFormWrapper}
